<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Vote Results Categories</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onVoteResultsCategoryCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="onCreateVoteResultsCategory()">
        <mat-icon>add</mat-icon>
        Add Vote Results Category
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="voteResultsCategories()"
      [columns]="voteResultsCategoriesColumns()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditVoteResultsCategory($event)"
      (deleteClick)="onDeleteVoteResultsCategory($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
